import React from 'react';
import { 
    Icon,
	FormControl,
    OutlinedInput,
    InputAdornment,
} from '@material-ui/core';

const UrlForm = (props) => {
  	return (
		<>
			<FormControl fullWidth size="small" variant="outlined">
                <OutlinedInput
                    id="outlined-adornment-amount"
                    value={props.url}
                //   onChange={handleChange('amount')}
                    startAdornment={
                        <InputAdornment position="start">
                            <Icon color="disabled">launch</Icon>
                        </InputAdornment>
                    }
                    labelWidth={0}
                />
            </FormControl>
        </>
  	)
}

export default UrlForm;